import { Component, OnInit, EventEmitter, Output , Input, ViewChild, ChangeDetectorRef} from '@angular/core';
import { UserService } from '../services/user.service';
import { AppointmentService } from '../services/appointment.service';
import { PaymentService } from '../services/payment.service';
import { environment } from '@env/environment';
import * as AppConstant from '../app.string';
import { TranslatePipe } from '../pipes/translate.pipe';
import { FacilityDetailsPipe } from '../pipes/facility-details.pipe';
import { GoogleTagsService } from '../services/google-tags.service';
import * as moment from 'moment';
import { PACKAGE, POINTSTYPEDEFAULT } from '@const';
import { POINTSTYPE, PromoDetails } from '@type';
import * as _ from 'lodash';
import { AltpaymentInputComponent } from '../components/altpayment-input/altpayment-input.component';
import { forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { PackageService } from '../services/package.service';
import { AlternatePaymentComponent } from '../components/alternate-payment/alternate-payment.component';
@Component({
  selector: 'app-health-package-confirm-request',
  templateUrl: './health-package-confirm-request.component.html',
  styleUrls: ['./health-package-confirm-request.component.scss'],
  providers: [TranslatePipe, FacilityDetailsPipe]
})
export class HealthPackageConfirmRequestComponent implements OnInit {

  @Input() pkgPrefer: any;
  @Input() requestInfo: any;
  @Input() reqConfirm:any;
  @Input() healthPkg:any;
  @Output() close: EventEmitter<any>;
  @Output() action: EventEmitter<any>;
  @Output() switchAction: EventEmitter<any>;
  @Output() next: EventEmitter<any>;

  public currency_code: any;
  public concept: any;
  public appConfig: any;
  public detail: any;
  public isReqRecieved: boolean;
  public openPayment: boolean;
  public payType: string;
  public paymentGatewayUrl: string;
  private facilityId;
  public chosenFacility: any;
  public selectedFacility: any;
  public paymentStatus: string;
  public paymentData: any;

  public selectedDirective: any;
  public selectedPackage;
  public selectedFacilityId;
  public selectedPatient;
  public patientPayable: any = 0;
  public isPaymentGatewayEnabled: boolean;
  public isPayableServices: any;
  public isEditApplicable: boolean;
  public isEnablePromo: boolean = false;
  public isEnableCoupon: boolean = false;
  public isEnablePoints: boolean = false;
  public readonly pointsType: POINTSTYPE = POINTSTYPEDEFAULT
  public chargeDetails: any = {};
  private promptPreset = {
    chargeData: {},
    discountData: {}
  }
  public discountDetails: PromoDetails
  public billingGroup: any;
  public flowType: any;
  public validationDetails: any
  public canPayToPract: boolean = false;
  public canPay: boolean = false;
  public canPayOptional: boolean = false
  public canPayOptionalGlobal: boolean = false
  public showEditPatient: boolean = false
  public prevPaymentCost: any = 0;
  public fetchingCharge: boolean = false;
  @ViewChild('coupon', { static: false }) coupon: AltpaymentInputComponent;
  @ViewChild('points', { static: false }) points: AltpaymentInputComponent;
  public chargeVatInfoRef:any;
  public chargeVatDetails:any;
  public prevPayment: Object = null;
  public state: 'FETCH' | 'COMPLETE' | 'ERROR' | 'COMPLETERESCHEDULEERROR';
  public enterReferral: boolean;
  public enablePayOnConsultForInsurance: boolean = false;
  public enableReferralCode: boolean = false;
  public referralControl: any;
  public referralCode: string = '';
  public selectedPract: any;
  public slot: any;  
  public bookingForConcepts: any;
  public bookingApplicableFacilities: any;
  public patientPayableApprox: any;
  public packageOnlyFlow:boolean;
  public packageConfirmView: boolean = false;
  public isBookingSubService: boolean;
  public selectedVisitType: any;
  public packageIndicator: any;
  public subServicesForAppointmentBooking: any;
  public careElementParams: any;
  public packageDefination: any;
  public consultationSelections: any;
  public isReschedule: boolean = false;
  public rescheduleParams: any;
  public isApplyingCode: boolean = false;
  public isPayableService: boolean = false;
  public selectedServicesDtl: any;
  public couponAdditionalParams: any;
  public isAutoApplyingCoupon: boolean = false;
  public selections:any = {};
  public lang;
  public apptConfirmDetails: any;
  public pkgApptDetail: any;
  public showPkgAccord: boolean = false;
  public showPaymentDtlAccord: boolean = false;
  public showInclServAccord: boolean = false;
  public showServiceIncludedModal: boolean = false;
  public selectedGrpService: any;
  public applicableServices
  public groupedServices
  public packageDetails: any;
  public selectedPackageDtl: any;
  public readonly footerApplicableStatus = ['A', 'C']
  public computedDetail: any;
  public isSubmitting: boolean = false;
  @ViewChild('altPayment', { static: false }) altPayment: AlternatePaymentComponent;
  constructor(private user: UserService, private apptService: AppointmentService, private paymentService:PaymentService, private translatePipe: TranslatePipe,private facilityPipe: FacilityDetailsPipe, private gtmService:GoogleTagsService, private cdf: ChangeDetectorRef, private packageService: PackageService) {
    this.close = new EventEmitter<any>();
    this.action = new EventEmitter<any>();
    this.switchAction = new EventEmitter<any>();
    this.next = new EventEmitter<any>();
  }

  ngOnInit(): void {
    this.healthPkg = this.packageService.getAllHpValues();
    console.log("altPayment 123", this.altPayment);
    // console.log('health-package-confirm-request requestInfo', this.requestInfo, 'healthPkg', this.healthPkg);
    this.selectedDirective = this.healthPkg.selectedDirective;
    this.selectedPackage = this.healthPkg?.isBookingSubService && this.healthPkg?.selectedPackage?._healthPackage ? this.healthPkg?.selectedPackage?._healthPackage : this.healthPkg?.selectedPackage;
    this.selectedFacilityId = this.healthPkg.choosenFacility.facilityId
    this.chosenFacility = this.healthPkg.choosenFacility;
    this.selectedPatient = this.healthPkg.selectedPatient;
    this.flowType = this.healthPkg.flowType;
    this.selectedPract = this.healthPkg?.selectedPract;
    this.slot = this.healthPkg?.selectedSlot;
    this.selectedFacility = this.healthPkg?.selectedFacility;
    this.facilityId = this.healthPkg?.choosenFacility.facilityId;
    this.selectedPatient = this.healthPkg?.selectedPatient;
    this.bookingForConcepts = this.healthPkg?.bookingForConcepts;
    this.chargeDetails = this.healthPkg?.chargeDetails;
    this.bookingApplicableFacilities = this.healthPkg?.bookingApplicableFacilities;
    this.patientPayableApprox = this.healthPkg?.patientPayableApprox
    this.isBookingSubService = this.healthPkg?.isBookingSubService || this.user?.getIsBookingSubService() || false;
    this.packageConfirmView = this.healthPkg?.packageConfirmView
    this.packageOnlyFlow = this.healthPkg?.packageOnlyFlow
    this.canPay = this.healthPkg?.canPay
    this.selectedVisitType = this.healthPkg?.selectedVisitType
    this.packageIndicator = this.healthPkg?.packageIndicator
    this.consultationSelections = this.healthPkg?.consultationSelections
    this.careElementParams = this.healthPkg?.careElementParams
    this.isReschedule = this.healthPkg?.reschedule;
    this.rescheduleParams = this.healthPkg?.toReschedule
    this.packageDefination = this.healthPkg?.packageDefination
    this.chargeVatDetails = this.healthPkg?.chargeVatDetails
    this.selectedServicesDtl = this.healthPkg?.selectedServicesDtl;
    this.selections = this.healthPkg?.selections;
    this.subServicesForAppointmentBooking = this.healthPkg?.subServicesForAppointmentBooking;
    this.currency_code = this.user.getCurrency() || environment['CURRENCY'];
    this.lang = this.user.currentLanguage;
    this. pkgApptDetail = this.healthPkg?.packageDetails;
    this.prevPayment = this.requestInfo?.exist ? this.requestInfo?.exist?.payment : null;
    this.isReqRecieved = this.reqConfirm? this.reqConfirm['confirmReq'] : false;
    this.computedDetail = this.healthPkg?.computedDetail
    this.user.getConfigurationInfo.subscribe(data => {
      this.isEnablePromo = (data['pxAppSettings'] && data['pxAppSettings']['enablePromoYn'] == 'Y') && !this.isReschedule ? true : false;
      this.isEnableCoupon = (data['pxAppSettings'] && data['pxAppSettings']['enableCouponYn'] == 'Y') && !this.isReschedule ? true : false;
      this.isEnablePoints = (data['pxAppSettings'] && data['pxAppSettings']['enablePointsYn'] == 'Y') && !this.isReschedule ? true : false;
      this.enablePayOnConsultForInsurance = data['pxAppSettings'] && data['pxAppSettings']['enablePayOnConsultForInsurance'] == 'Y' ? true : false;
      if (this.requestInfo?.visitType) {
        this.enableReferralCode = this.requestInfo?.visitType == 'HOMECARE' ? data['pxAppSettings'] && data['pxAppSettings']['referral'] && data['pxAppSettings']['referral']['canReferForVC'] : data['pxAppSettings'] && data['pxAppSettings']['referral'] && data['pxAppSettings']['referral']['canReferForAppt'];
        this.referralControl = data['pxAppSettings'] && data['pxAppSettings']['referral']['controls'];
      }
      this.paymentGatewayUrl = data.features['paymentGateway']['paymentGatewayUrl']
    })
    if(!this.isReqRecieved){
      this.isEditApplicable = true
    }
    this.paymentStatus = this.reqConfirm? this.reqConfirm['status'] : null
    this.paymentData = this.reqConfirm? this.reqConfirm['data'] : null
    this.user.getConfigurationInfo.subscribe(data => {
      this.appConfig = data;
      this.paymentGatewayUrl = data.features['paymentGateway']['paymentGatewayUrl']
      this.isPaymentGatewayEnabled = data.features.paymentGateway.enabled
      this.isPayableService = data.features.payableServices['services']
      this.getPageConfiguration();
    })
    this.concept = this.requestInfo?.selectedPkg
    for(let l in this.concept.detail){
      if(this.concept.detail[l].locale==this.user.currentLanguage){
          this.detail=this.concept.detail[l];
      }
    }

    if(this.isBookingSubService) {
      this.fetchPackageDetails(this.pkgApptDetail);
    }
    // this.getAppointmentCharges();
    // this.concept.facilities.find( item => {
    //   if(item.facilityId == this.requestInfo.selectedFacility['facilityId']){
    //     this.chosenFacility = item.controls;
    //   }
    //   console.log("ccccc", this.chosenFacility)
    // })
  }

  ngAfterViewInit() {
    if (this.altPayment) {
      this.altPayment.checkAutoApplyCoupons();
    }
  }

  private getPageConfiguration() {
    this.isPayableService = false;
    let patientPayable = this.chosenFacility?.controls?.discountCharge || this.chosenFacility?.controls?.charge || null
    // if (this.selectedVisitType === 'CLINIC' && this.packageIndicator === 'ORDERSET') {
      // if (this.user.getPaymentGateway && this.user.canPayForService('serviceswithorder') && this.chosenFacility?.controls?.payableOnline === 'true') {
        this.isPayableService = true;
      // }
    // } else {
      // this.isPayableService = true;
    // }
    if (!this.isPayableService) {
      this.patientPayableApprox = patientPayable;
    }
    this.couponAdditionalParams = {
      package: this.selectedPackage,
      patient: this.selectedPatient,
      isPackage: true,
    }
  }

  public closeConfirmModal(){
    this.close.emit('CLOSE');
  }

  public closeServiceModal() {
    this.showServiceIncludedModal = false;
  }

  getSubTitle(names){
    for (let l in names){
      if(names[l].locale==this.user.currentLanguage){
        return names[l].description;
      }
      else
      {
        return names[l].description;
      }
    }
  }

  getTitle(names){
    if (names.length == 0) {
        return '';
    } else {
        let t = names.find(name => {
            return name.locale == this.user.currentLanguage
        })
        if (t) {
            return t.name;
        } else {
            return names[0].name;
        }
    }
  }

  checkFunction(type,name){
    this.request(type,name);
  }

  request(type, name){

    let notify = this.chosenFacility.controls.notification
    if (!notify) {
      let directiveFacility = this.selectedDirective.facilities.find(fac => fac.facilityId == this.chosenFacility.facilityId)
      if (!directiveFacility)
        directiveFacility = this.selectedDirective.facilities.find(fac => fac.facilityId == '*ALL')
      if (directiveFacility)
        notify = directiveFacility.controls.notification;
    }
    this.facilityId = this.requestInfo.selectedFacility['facilityId'] //this.concept['selectedFacilityId']
    var conceptName = this.getTitle(name);
    let facility = this.facilityPipe.transform(this.requestInfo.selectedFacility['facilityId'], 'facilityName');
    let facilityName = this.translatePipe.transform(facility, 'LOCALE', 'name')
    // console.log("this.pkgPrefer['patient']", this.pkgPrefer['patient'])
    var tempBody={
        payment:false,
        description: this.translatePipe.transform(this.selectedPackage.name, 'LANGARRAY', 'name'), //conceptName,
        personId: this.user.getPersonId(),
        mobile:this.user.getPersonMobile(),
        email:this.user.getPersonEmail(),
        preferredDate: moment(this.requestInfo['selectedSlot']['slot']['date'], 'YYYY-MM-DD').format('YYYY-MM-DD'),
        facilityName: facilityName,
        charge: this.patientPayable,
        chargeCurrency: this.currency_code,
        patientName: this.selectedPatient.personname,
        patientId: this.selectedPatient.uhid,
        notify: notify || null ,
        locale:this.user.currentLanguage,
        directiveName: this.translatePipe.transform(this.selectedPackage.name, 'LANGARRAY', 'name'), //conceptName,
        packComment: null,
        packageDetails: {
          directiveCode: this.selectedDirective.code,
          directiveGroup: this.selectedDirective.directiveGroup,
          conceptCode: this.selectedPackage.code,
          directiveDesc:this.selectedDirective.name,
          conceptDesc: this.selectedPackage.name
        },
    }
    // if(this.chosenFacility.controls.payableOnline){
    //     tempBody.charge=this.pkgPrefer['pkgCost'];
    //     tempBody.chargeCurrency=this.chosenFacility.chargeCurrency;
    //     if(type=='PAY'){
    //         tempBody.payment=true;
    //         tempBody.patientName=this.pkgPrefer['patient']['personname'];
    //     }
    // }
    // if(type=='REQ'){
    //     tempBody.patientId= this.selectedPatient.uhid
    //     tempBody.patientName=this.selectedPatient.personname
    // }else if(type=='NEWREQ'){
    //     tempBody.patientName=this.selectedPatient.personname
    // }
    // if(this.patient === 'new'){
    //     tempBody.patientName = this.patientName
    // }
    // else if(this.patient != 'new'){
    //   tempBody.patientId=this.pkgPrefer['patient'].uhid;
    //   tempBody.patientName=this.pkgPrefer['patient'].personname;
    // }
    // console.log("tenpoBoddyyy",tempBody);
    // this.pay(tempBody.charge,tempBody);
    if(type=='PAY'){
        this.pay(tempBody.charge,tempBody);
    }else{
        this.serviceRequest(tempBody);
    }

}
  public onTextInput(ev?: any) {
    // console.log('event',ev)
    let regexValidation = this.referralControl.regex;
    if (regexValidation) {
      const regex = new RegExp(regexValidation, 'g')
      let value = ev.target.value;
      let newVal = value.replace(regex, '');
      ev.target.value = newVal;
      this.referralCode = newVal;
    }
    }
  public removeReferral() {
    this.referralCode = ''
  }
serviceRequest(Body) {
  this.apptService.confirmPackageRequest(Body).subscribe( data => {
    // console.log("serviceRequest res data",data)
    if (data.status == "SUCCESS"){
        this.isReqRecieved = true;
        this.isEditApplicable = false
      this.paymentStatus = 'REQ'
      this.gtmService.pushGTMEvent('Health Packages', 'appointment_confirmation', { value: +Body['charge'], request_status:'Success' , booking_no:data['data']?.reqId?.request_id});
    }
  }, err => {
    this.gtmService.pushGTMEvent('Health Packages', 'appointment_confirmation', { value: +Body['charge'], request_status:'Failed:' + err });
  })
}

public pay(amount,reqBody) {

  this.payType = 'C'
  var tempType;
  var body
    if(reqBody==null){
      tempType=false;
      body={
          personId: this.user.getPersonId(),
          linkedPersonId: this.selectedPatient.personid,
          patientId: this.selectedPatient.uhid,
          amount:amount,
          currency:this.currency_code,
          episodeType:'R',
          encounterId:'0',
          requestType:'DEPOSIT',
      }
      reqBody={
          personId: this.user.getPersonId(),
          linkedPersonId: this.selectedPatient.personid,
          patientId: this.selectedPatient.uhid,
          amount:amount,
          currency:this.currency_code,
          episodeType:'R',
          encounterId:'0',
    }
  }else{
      tempType=true;
      body={
          personId: this.user.getPersonId(),
          linkedPersonId: this.selectedPatient.personid,
          patientId:  this.selectedPatient.uhid,
          amount:amount,
          currency:this.currency_code,
          episodeType:'R',
          encounterId:'0',
          requestType:'SRVREQ',
          // request:reqBody
      }
  }
    this.apptService.startTransaction(body, reqBody).subscribe((response: any) => {
      console.log("environment.DEFAULT_EMAIL", environment.DEFAULT_EMAIL);
      let appointment = {
        _orderId: response['transaction_id'],
        saved_card_token: response['saved_card_token'],
        saved_card_details: response['savedCards'] && response['savedCards'].length ? response['savedCards'].map(c => c['cardsInfo']) : [],
        saved_stc_details: response['savedSTCNumber'] && response['savedSTCNumber'].length ? response['savedSTCNumber'].map(c => c['cardsInfo']) : [],
        uhid: this.selectedPatient.uhid,
        email:  environment.DEFAULT_EMAIL || null,
        mobile_no: ''
      }
      let url = window['location'];
      let transaction_id = response['transaction_id'];
      let payment = true;
      let method = 'SRVREQ';
      // let date = this.user.getMoment(this.slot['date']).format("YYYYMMDD");
      // let slot = this.user.getMoment(this.slot['slot'], 'HH:mm').format('HHmm')
      let retry = `pt=${this.payType}&cost=${amount}`;
      // let visitType =  'VCN' ;
     
      let retryJson = JSON.stringify(retry);
      this.gtmService.pushGTMEvent('Health Packages', 'appointment_confirmation', { value:amount,booking_no: response['transaction_id'] });
      
      let params = `orderid=${transaction_id}&f=${this.facilityId}&h=${this.selectedPatient.uhid}&${retry}`
      // let params = `orderid=${transaction_id}&f=${this.facilityId}&s=${this.speciality['id']}&p=${this.practitioner['id']}&d=${date}&t=${slot}&h=${this.patient['id']}&v=${visitType}&c=${flowType}&${retry}`
      console.log('startTransaction+++++url', url);
      let diff = (href, origin) => href.split(origin).join('');
      let returnURL = diff(url['href'].split('?')[0], url['origin'] + '/') + `?s=1&method=SRVREQ&p=${btoa(params)}`;
      let paymentInfo = {
        _returnURL: returnURL,
        currency: this.user.getCurrencyForPayment() ||  this.currency_code,
        charge: amount,
        paymentgatewayurl: this.paymentGatewayUrl
      }
      console.log('startTransaction+++++paymentInfo', paymentInfo);
      this.paymentService.setPaymentParams(appointment, paymentInfo).subscribe(_ => {
        // this.payment.emit({ name: 'openPaymentCheckout' });
        this.openPayment = true;
        this.user.setStorage(AppConstant.HEALTHPKG_REQ, JSON.stringify(this.requestInfo));
      })
    })
}

public closeModal(type) {
  this.action.emit(type);
}

public switchActions(type){
  this.switchAction.emit(type);
}

  //Promo and coupon logics
  private calculatePayable() {
    let couponDiscount = this.chargeDetails.couponDiscount || 0;
    let pointsDiscount = this.pointsType == 'PAYMENT' ?  (this.chargeDetails.pointsDiscount || 0) : 0;
    let additionalCharge = Number(this.chargeDetails.additionalCharge) || 0
    this.chargeDetails.netPayable = this.chargeDetails.discountedPayable + additionalCharge - couponDiscount - pointsDiscount;
    this.chargeDetails.totalVat = this.calculateVatDisplayAmount(this.chargeDetails.vatAmount, this.chargeDetails.vatExemptAmount)
    this.chargeDetails._payableWithoutCoupon = this.chargeDetails.netPayable + couponDiscount;
    this.chargeDetails._payableWithoutPoints = this.chargeDetails.netPayable + pointsDiscount;
    this.resetPaymentFlow()
  }

  private resetPaymentFlow() {
    // if (Number(this.chargeDetails.netPayable) <= 0) {
    //   this.chargeDetails.netPayable = 0;
    //   this.canPay = false;
    // } else {
    //   this.canPay = true;
    // }
    // this.chargeDetails.netPayable = this.user.fixDecimalPlaces(Number(this.chargeDetails.netPayable));
    // // this.chargeVatDetails['vatDisplayAmount']=this.calculateVatDisplayAmount(this.chargeDetails.vatAmount,this.chargeDetails.vatExemptAmount);
    // this.chargeDetails = _.cloneDeep(this.chargeDetails)

   let canPay = true;
    if (Number(this.chargeDetails.netPayable) <= 0) {
      this.chargeDetails.netPayable = 0;
      canPay = false;
    }
    this.canPay = this.isPayableService && canPay;
    this.chargeDetails.netPayable = this.user.fixDecimalPlaces(Number(this.chargeDetails.netPayable));
    this.chargeDetails.yetToPay = Number(this.chargeDetails.netPayable) > 0
    this.chargeDetails = _.cloneDeep(this.chargeDetails)
    setTimeout(_ => {
      if (this.altPayment) {
        console.log("Calling auto coupon");
        this.altPayment.checkAutoApplyCoupons();
      }
      this.cdf.detectChanges();
      this.fetchingCharge = false;
    }, 500)
  }

  public applyingPromoCode(event) {
    this.fetchingCharge = event.status
  }
  public applyingCouponCode(event) {
    this.fetchingCharge = event.status
    this.isAutoApplyingCoupon = event.status && event.autoApply
  }
  public applyingPoints(event) {
    this.fetchingCharge = event.status
  }
  public appliedPromocode(event) {
    if (event.type == 'APPLY') {
      this.applyDiscount(event.data)
    } else if (event.type == 'REMOVE') {
      this.removeDiscounts();
    }
  }
  public couponApplied(event) {
    if (event.type == 'APPLY') {
      this.chargeDetails.couponTitle = []
      this.applyCouponcode(event.data)
    } else if (event.type == 'REMOVE') {
      this.removeCouponCode()
    }
  }
  public pointsApplied(event) {
    if (event.type == 'APPLY') {
      this.chargeDetails.pointsData = {}
      this.applyPoints(event.data)
    } else if (event.type == 'REMOVE') {
      this.removePoints()
    }
  }

  private applyDiscount(response) {
    this.chargeDetails.appliedpromocodedtls = response.appliedpromocodedtls;
    this.chargeDetails.promoDiscount = Number(response.calculatedDiscountAmt);
    this.chargeDetails.netPayable = Number(response.netservicecharge)
    this.chargeDetails.discountedPayable = Number(response.netservicecharge)
    this.chargeDetails.isPromoApplied = response.appliedpromocodedtls?.length > 0;
    if(response.netchargedtls && response.netchargedtls.length>0){
      this.chargeVatDetails['vatDisplayAmount']=this.calculateVatDisplayAmount(response.netchargedtls[0].taxAmount,response.netchargedtls[0].taxExemptAmount);
    }
    if (response.pointsApplied) {
      this.applyPoints({ pointsDerivative: response.pointsApplied })
    } else {
      this.removePoints()
    }
    if (response.appliedDiscount) {
      this.applyGeneralDiscount(response)
    } else {
      this.removeGeneralDiscount()
    }
    this.handlePostDiscount()
  }

  private applyGeneralDiscount(response) {
    this.chargeDetails.generalDiscount = Number(response.calculatedDiscountAmt);
    this.chargeDetails.isGeneralDiscountApplied = this.chargeDetails.generalDiscount > 0
    this.chargeDetails.generalDiscountDetails = { services: response.appliedDiscount }
  }
  private removeGeneralDiscount() {
    this.chargeDetails.generalDiscount = 0;
    this.chargeDetails.isGeneralDiscountApplied = false;
    this.chargeDetails.generalDiscountDetails = null;
  }

  public removeDiscounts(fromCoupon: boolean = false) {
    this.fetchingCharge = true;
    this.chargeDetails.netPayable = Number(this.chargeDetails.totalAmount)
    this.chargeDetails.discountedPayable = Number(this.chargeDetails.totalAmount)
    this.chargeVatDetails['vatDisplayAmount']=this.calculateVatDisplayAmount(this.chargeDetails.vatAmount,this.chargeDetails.vatExemptAmount);
    this.chargeDetails.isPromoApplied = false;
    this.chargeDetails.promoDiscount = 0;
    this.removePoints()
    this.removeGeneralDiscount()
    if (!fromCoupon) {
      this.handlePostDiscount()
    }
  }
  // private handlePostDiscount() {
  //   let isCouponHandled = this.coupon && this.chargeDetails.isCouponApplied
  //   let isPointsHandled = this.points && this.chargeDetails.isPointsApplied && this.pointsType == 'PAYMENT'

  //   if (isCouponHandled || isPointsHandled) {
  //     if (isCouponHandled) this.coupon.removeAllCoupons(true);
  //     if (isPointsHandled) this.points.removeAllPoints(!isCouponHandled);
  //   } else {
  //     this.calculatePayable()
  //   }
  // }

    private handlePostDiscount() {
    let isCouponHandled = this.altPayment && this.chargeDetails.isCouponApplied
    let isPointsHandled = this.altPayment && this.chargeDetails.isPointsApplied && this.pointsType == 'PAYMENT'
    if (isCouponHandled || isPointsHandled) {
          // if (isCouponHandled) this.altPayments.clearAllCoupons(true); // Replaced with alternate-payments component
          // if (isPointsHandled) this.altPayments.clearAllPoints(!isCouponHandled); // Replaced with alternate-payments component
    } else {
      this.calculatePayable()
    }
  }
  private async applyCouponcode(response) {
    let wellnessCoupon = response.appliedcouponcodedtls.find(c => c.isWellnessCoupon);
    if (wellnessCoupon) {
      this.removeDiscounts()
      if (response.additionalDiscount) {
        this.applyDiscount(response.additionalDiscount)
      }
    }
    this.chargeDetails.appliedcouponcodedtls = response.appliedcouponcodedtls;
    this.chargeDetails.couponTitle = this.chargeDetails.appliedcouponcodedtls.map(item => item.couponTitle)
    this.chargeDetails.couponDiscount = Number(response.value);
    this.chargeDetails.isCouponApplied = response.appliedcouponcodedtls.length > 0;
    this.calculatePayable()
  }
  private removeCouponCode() {
    this.chargeDetails.appliedcouponcodedtls = null
    this.chargeDetails.couponTitle = []
    this.chargeDetails.isCouponApplied = false;
    this.chargeDetails.couponDiscount = 0;
    this.calculatePayable()
  }
  private applyPoints(response) {
    this.chargeDetails.appliedPoints = response.pointsDerivative;
    this.chargeDetails.pointsDiscount = Number(response.pointsDerivative.amount);
    this.chargeDetails.isPointsApplied = this.chargeDetails.pointsDiscount > 0
    if(this.pointsType == 'PAYMENT')
      this.calculatePayable()
  }
  private removePoints() {
    this.chargeDetails.appliedPoints = null;
    this.chargeDetails.pointsDiscount = 0;
    this.chargeDetails.isPointsApplied = false;
    if (this.pointsType == 'PAYMENT')
      this.calculatePayable()
  }

  private calculateVatDisplayAmount(vatamt,vatexpamt){
    let vatAmount, vatExemptedAmt,vatDisplayAmount;
    vatAmount = (vatamt && vatamt!='') ? parseFloat(vatamt) : 0;
    vatExemptedAmt = (vatexpamt && vatexpamt!='') ? parseFloat(vatexpamt) : 0;
    vatDisplayAmount = vatAmount - vatExemptedAmt;
    vatDisplayAmount = vatDisplayAmount.toString();
    return vatDisplayAmount;
  }


  public submitRequest(type: 'PAY' | 'REQ') {
    if (this.isApplyingCode) return;
    this.isSubmitting = true;
    if (this.canPay) {
      this.initTransaction()
    } else {
      this.initRequest()
    }
  }

  private initRequest(){
    let payload = this.generateRequestParams('REQ')
    console.log("initRequest payload",payload);
    this.selections = this.selections || {};
    if (this.packageOnlyFlow){
      this.apptService.confirmPackageRequest(payload)
      .subscribe(data => {
        this.selections['paymentError'] = false;
        this.openReview(data);
        this.isSubmitting = false
      })
    } else if (this.selectedVisitType === 'HOMECARE' && !this.consultationSelections?.selectedPractitioner) {
      this.apptService.confirmHCAppointment(payload)
      .subscribe((data) => {
        this.selections['confirmObj'] = Array.isArray(data) ? data?.[0]?.[0] : data;
        this.selections['paymentError'] = false;
        this.openReview(data);
        data['appointmentDateTime'] = data['apptdate'] + " " + data['appttime'];
        this.isSubmitting = false
      });
    } else {
      this.apptService.confirmAppointment(payload)
      .subscribe(data => {
        this.selections['confirmObj'] = data;
        this.selections['paymentError'] = false;
        this.openReview(data);
        this.isSubmitting = false
      })
    }
  }

  public applyingAltPaymentCode(event) {
    this.isApplyingCode = event.status
    this.isAutoApplyingCoupon = event.status && event.autoApply
    this.cdf.detectChanges()
  }

  public appliedAltPayment(event) {
    if (event.computedDetail) {
      this.computedDetail = event.computedDetail;
    }
    if (event.apptDetail) {
      this.slot = event.apptDetail;
    }
    if (event.chargeDetails) {
      this.chargeDetails = event.chargeDetails;
    }
    let canPay = true;
    if (Number(this.chargeDetails.netPayable) <= 0) {
      this.chargeDetails.netPayable = 0;
      canPay = false;
    }
    this.chargeDetails.yetToPay = Number(this.chargeDetails.netPayable) > 0
    // if(this.chargeDetails.netPayable == 0){
    //   canPay = false;
    // }
    this.canPay = this.isPayableService && canPay;
    // this.chargeDetails.netPayable = this.masterService.fixDecimalPlaces(Number(this.chargeDetails.netPayable));
    // this.chargeDetails.yetToPay = Number(this.chargeDetails.netPayable) > 0
    // this.chargeDetails = _.cloneDeep(this.chargeDetails)
    this.isApplyingCode = false;
    this.isAutoApplyingCoupon = false;
    this.cdf.detectChanges();
  }

    public async openReview(data) {
      // console.log("openReview appointment data",data, 'this.selectedPatient', this.selectedPatient, 'health pkg', this.healthPkg);
    const selections = {
      paymentError: this.selections['paymentError'],
      selectedPackage: this.selectedPackage,
      bookingForConcepts: this.bookingForConcepts,
      chosenFacility: this.chosenFacility,
      selectedDate: this.slot.date,
      selectedPatient: this.selectedPatient,
      selectedSlot: this.slot,
      isReschedule: this.isReschedule
    }

    const appointment = this.selections?.['confirmObj']?.['response'] || this.selections?.['confirmObj'] || {}
    if (appointment && typeof appointment === 'object') {
      appointment.appointmentId = appointment?.appointmentId || appointment?.apptRefNumber || appointment?.apptrefnum
    }
    this.user.getUpcomingAppointments().subscribe(res => {
      let apptDtl = res?.data?.appointments?.find(a => a.appointmentId == (data?.appointmentId || data?.apptRefNumber || data?.apptrefnum))
    this.apptConfirmDetails = {
      patientId: this.selectedPatient?.uhid,
      patientName: this.selectedPatient?.personname,
      packageDetails: apptDtl?.packageInfo?.packageDetails,
      facilityId: apptDtl?.facilityId,
      apptDateTime: apptDtl?.appointmentDateTime,
      paymentStatus: data?.status,
      apptRefNumber: appointment.appointmentId,
      confirmReq: true
    }
    this.user.setAppointmentRefNum(appointment.appointmentId);
    this.next.emit({data: this.apptConfirmDetails,state: "CONFIRM_PACKAGE",key: "confirmPkg",});
    })

  }

  public initTransaction() {
    let transParams = this.generateTransactionParams();
    let reqParams = this.generateRequestParams('PAY');
    this.payType = 'C';
    let amount = reqParams['charge'];
    console.log("initTransaction transParams", transParams, 'reqParams', reqParams);
    this.apptService.startTransaction(transParams, reqParams)
    .subscribe((response: any) => {
      this.isSubmitting = false;
      let appointment = {
        _orderId: response['transaction_id'],
        saved_card_token: response['saved_card_token'],
        saved_card_details: response['savedCards'] && response['savedCards'].length ? response['savedCards'].map(c => c['cardsInfo']) : [],
        saved_stc_details: response['savedSTCNumber'] && response['savedSTCNumber'].length ? response['savedSTCNumber'].map(c => c['cardsInfo']) : [],
        uhid: this.selectedPatient.uhid,
        email:  environment.DEFAULT_EMAIL || null,
        mobile_no: ''
      }
      let url = window['location'];
      let transaction_id = response['transaction_id'];
      let payment = true;
      let method = 'SRVREQ';
      // let date = this.user.getMoment(this.slot['date']).format("YYYYMMDD");
      // let slot = this.user.getMoment(this.slot['slot'], 'HH:mm').format('HHmm')
      let retry = `pt=${this.payType}&cost=${amount}`;
      // let visitType =  'VCN' ;
     
      let retryJson = JSON.stringify(retry);
      this.gtmService.pushGTMEvent('Health Packages', 'appointment_confirmation', { value:amount,booking_no: response['transaction_id'] });
      
      let params = `orderid=${transaction_id}&f=${this.facilityId}&h=${this.selectedPatient.uhid}&${retry}`
      // let params = `orderid=${transaction_id}&f=${this.facilityId}&s=${this.speciality['id']}&p=${this.practitioner['id']}&d=${date}&t=${slot}&h=${this.patient['id']}&v=${visitType}&c=${flowType}&${retry}`
      let diff = (href, origin) => href.split(origin).join('');
      let returnURL = diff(url['href'].split('?')[0], url['origin'] + '/') + `?s=1&method=SRVREQ&p=${btoa(params)}`;
      let paymentInfo = {
        _returnURL: returnURL,
        currency: this.user.getCurrencyForPayment() ||  this.currency_code,
        charge: amount,
        paymentgatewayurl: this.paymentGatewayUrl
      }
      // console.log("paymentInfo",paymentInfo)
      this.paymentService.setPaymentParams(appointment, paymentInfo).subscribe(_ => {
        // this.payment.emit({ name: 'openPaymentCheckout' });
        this.openPayment = true;
        this.user.setStorage(AppConstant.HEALTHPKG_REQ, JSON.stringify(this.requestInfo));
      })
    })
  }
    private generateRequestParams(type) {
    return this.selectedVisitType === 'HOMECARE' && !this.consultationSelections?.selectedPractitioner ? this.generateRequestParamsForHomecare((type === 'PAY' ? 'Y': 'N')) : this.generateRequestParamsForPackage(type);
  }

  private generateRequestParamsForHomecare(isPaying: 'Y' | 'N' = 'N') {
    // if (!this.selectedPatient || !this.selectedPatient.uhid) {
    //   console.error('Selected patient or patient uhid is null');
    //   return null;
    // }
    // if (!this.chosenFacility) {
    //   console.error('Chosen facility is null or undefined');
    //   return null;
    // }
    // let serviceList = this.homecarePackageService;
    // if (this.homeCareAddlCharge?.['code']) {
    //   serviceList.push({
    //     name: this.homeCareAddlCharge['name'],
    //     code: this.homeCareAddlCharge['code'],
    //     serviceCost: this.homeCareAddlCharge['value'],
    //   });
    // }
    // return {
    //   resourceId: '',
    //   uhid: this.selectedPatient?.uhid,
    //   clinicCode: this.selectedSlot.clinic,
    //   // clinicCode: this.selectedAppointment['homeCareClinicCode'] || this.selectedAppointment['clinicCode'],
    //   patientPersonId: this.selectedPatient?.personid,
    //   personName: this.selectedPatient?.personname,
    //   dob: moment(this.selectedPatient?.dob).format("YYYY-MM-DD"),
    //   gender: this.selectedPatient?.gender,
    //   patientName: this.selectedPatient?.personname,
    //   serviceDetails: serviceList,
    //   noOfSlots: this.selectedSlot?.choosenSlots?.length,
    //   isPromoCodeAppliedYn: this.getPromoCodeApplystatus('PROMO', isPaying),
    //   isCouponAppliedYn: this.getPromoCodeApplystatus('COUPON', isPaying),
    //   isPointsAppliedYn: this.getPromoCodeApplystatus('POINTS', isPaying),
    //   coupons: this.getAppiledCoupons('COUPON', isPaying),
    //   appliedPromoCodes: this.getAppiledCoupons('PROMO', isPaying),
    //   appliedPoints: this.getAppiledCoupons('POINTS', isPaying),
    //   appointments: this.getAppointments(serviceList, isPaying),
    //   apptType: {
    //     name: "Home care visit",
    //     value: "HC"
    //   },
    //   patientId: this.selectedPatient.uhid,
    //   patientGender: this.selectedPatient.gender,
    //   patientDOB: moment(this.selectedPatient.dob).format("YYYY-MM-DD"),
    //   location: {
    //     lat: this.selectedLocation?.lat,
    //     lng: this.selectedLocation?.lng,
    //     address: `${this.selectedLocation?.region || ''} ${this.selectedLocation?.address || ''}`
    //   },
    //   serviceLocation: {
    //     lat: this.chosenFacility?.clinicLocation ? this.chosenFacility?.clinicLocation.split(',')[0] : "",
    //     lng: this.chosenFacility?.clinicLocation ? this.chosenFacility?.clinicLocation.split(',')[1] : "",
    //     address: this.chosenFacility?.clinicAddress
    //   },
    //   clinicLocation: this.chosenFacility?.clinicLocation,
    //   amount: this.chargeDetails.totalAmount,
    //   payableAmount: this.chargeDetails.netPayable,
    //   contactDetails: {},
    //   facilityId: this.chosenFacility?.facilityId,
    //   resourceType: this.chosenFacility?.controls?.packageCalendarResourceClass || this.chosenFacility?.resourceType,
    //   discount: {
    //     discountApplied: false,
    //     discountAmount: 0,
    //     discountValue: null,
    //     discountMethod: {
    //       name: "%",
    //       code: "P"
    //     },
    //     discountReasonDesc: ""
    //   },
    //   taskInfo: {},
    //   recurringYn: 'N',
    //   recurringCount: null,
    //   recurringFrequency: null,
    //   groupId: null,
    //   billingCategory: {
    //     name: 'CASH',
    //     value: 'CASH'
    //   },
    //   billingGroup: {
    //     name: 'CASH',
    //     value: 'CASH'
    //   },
    // }
  }

    private generateRequestParamsForPackage(type: 'PAY' | 'REQ') {
    if (!this.selectedPatient || !this.selectedPatient.uhid) {
      console.error('Selected patient or patient uhid is null');
      return null;
    }
    if (!this.chosenFacility) {
      console.error('Chosen facility is null or undefined');
      return null;
    }
    let notify = this.chosenFacility?.controls?.notification
    if (!notify && this.packageOnlyFlow) {
      let directiveFacility = this.selectedDirective?.facilities?.find(fac => fac.facilityId == this.chosenFacility?.facilityId)
      if (!directiveFacility)
        directiveFacility = this.selectedDirective?.facilities?.find(fac => fac.facilityId == '*ALL')
      if (directiveFacility)
        notify = directiveFacility.controls.notification;
    }
    let serviceToBook = null;
    let subServicesForAppointmentBooking = null;
    let homeCareAddlCharge = null;
    if (!this.isBookingSubService) {
      serviceToBook = this.bookingForConcepts.map(bookingForConcept => {
        return {
          directiveCode: bookingForConcept?._directiveRef?.code,
          directiveGroup: bookingForConcept?._directiveRef?.directiveGroup,
          conceptCode: bookingForConcept?.code,
          directiveDesc: bookingForConcept?._directiveRef?.name,
          conceptDesc: bookingForConcept?.name
        }
      })
    } else {
      subServicesForAppointmentBooking = this.subServicesForAppointmentBooking
    }
    // if (this.homeCareAddlCharge?.code) {
    //   homeCareAddlCharge = this.homeCareAddlCharge
    // }
    const isPaying = type === 'PAY' ? 'Y' : 'N'
    let payload = {
      payment: type == 'PAY',
      isBackgroundProcess: false,
      description: this.translatePipe.transform(this.selectedPackage?.name, 'LANGARRAY', 'name'),
      personId: this.user.getPersonId(),
      mobile: this.user.getPersonMobile(),
      email: this.user.getPersonEmail(),
      preferredDate: moment(this.slot.date, 'YYYY-MM-DD').format('YYYY-MM-DD'),
      facilityName: this.translatePipe.transform(this.chosenFacility['facilityId'], 'FACNAME'),
      charge: this.chargeDetails?.netPayable,
      chargeCurrency: this.currency_code,
      currency: "SAR",
      patientName: this.selectedPatient?.personname,
      patientId: this.selectedPatient?.uhid,
      notify: notify || null,
      locale: this.lang,
      directiveName: this.translatePipe.transform(this.selectedPackage?.name, 'LANGARRAY', 'name'),
      packageDetails: {
        directiveCode: this.selectedDirective?.code,
        directiveGroup: this.selectedDirective?.directiveGroup,
        conceptCode: this.selectedPackage?.code,
        directiveDesc: this.selectedDirective?.name,
        conceptDesc: this.selectedPackage?.name,
        packageCategory: this.careElementParams.careElementType,
        packageMode: this.selectedVisitType,
        consultationMode: this.careElementParams?.consultationType ? this.careElementParams?.consultationType : this.consultationSelections?.appointmentType,
        serviceToBook: serviceToBook,
        subServicesForAppointmentBooking: subServicesForAppointmentBooking,
        homeCareAddlCharge: homeCareAddlCharge,
        packageDefination: this.packageDefination
      },
      packComment: null,
      billingGroup: 'CASH',
      insuranceFinDtls: null,
      source: 'PXPORTAL',
      appointmentNumber: this.rescheduleParams ? this.rescheduleParams.appointmentId : null,
      patientPersonId: this.selectedPatient['personid'],
      packageIndicator: this.selectedPackage?.packageDtls?.pacakgeIndicator,
      modeOfService: this.selectedVisitType,
      referralCode: this.referralCode ? this.referralCode : null,
    }
    if (!this.packageOnlyFlow){
      let tmp = {
        appointmentRequest: this.generateRegistrationParams(),
        isPackage: true,
        uhid: this.selectedPatient['uhid'],
        facilityId: this.selectedFacility['id'],
        clinicCode: this.slot['clinicCode'],
        date: this.slot['date'],
        time: this.slot['slot'],
        patientPersonId: this.selectedPatient['personid'],
        personName: this.selectedPatient['personname'],
        patientName: this.selectedPatient['personname'],
        dob: moment(this.selectedPatient['dob']).format('YYYY-MM-DD'),
        gender: this.selectedPatient['gender'],
        resourceId: this.resourceId,
        resourceClass: this.resourceClass,
        resourceType: this.resourceClass,
        isPackageVisit: true,
        isPromoCodeAppliedYn: this.isPromoApplied(),
        isCouponAppliedYn: this.isCouponApplied(),
        isPointsAppliedYn: this.isPointsApplied(),
        coupons: this.getAppiledCoupons('COUPON', isPaying),
        appliedPromoCodes: this.getAppiledCoupons('PROMO', isPaying),
        appliedPoints: this.getAppiledCoupons('POINTS', isPaying),
        referralCode: this.referralCode ? this.referralCode : null,
        visitType: PACKAGE,
        userAction: PACKAGE,
        localeCode: this.lang
      }
      return {...payload,...tmp}
    }
    return payload
  }

    private generateRegistrationParams() {
    var body = {
      uhid: this.selectedPatient['uhid'],
      facilityId: this.selectedFacility['id'],
      clinicCode: this.slot['clinicCode'],
      date: this.slot['date'],
      time: this.slot['slot'],
      patientPersonId: this.selectedPatient['personid'],
      personName: this.selectedPatient['personname'],
      dob: moment(this.selectedPatient['dob']).format('YYYY-MM-DD'),
      gender: this.selectedPatient['gender'],
      patientName: this.selectedPatient['personname'],
    }
    return body;
  }

  private isPromoApplied() {
    return this.chargeDetails && this.chargeDetails?.isPromoApplied ? 'Y' : 'N'
  }
  private isCouponApplied() {
    return this.chargeDetails && this.chargeDetails?.isCouponApplied ? 'Y' : 'N'
  }
  private isPointsApplied() {
    return this.chargeDetails && this.chargeDetails?.isPointsApplied ? 'Y' : 'N'
  }
  private getPromos() {
    return this.isPromoApplied() ? this.chargeDetails?.appliedpromocodedtls : null;
  }
  private getCoupons() {
    return this.isCouponApplied() ? this.chargeDetails?.appliedcouponcodedtls : null;
  }
  private getPoints() {
    return this.isPointsApplied() ? this.chargeDetails?.appliedPoints : null;
  }


  //use this promo and coupon logics for the new promo and coupon UI
  public getPromoCodeApplystatus(type, isPaying: 'Y' | 'N') {
    console.log('getPromoCodeApplystatus', type, isPaying, this.chargeDetails)
    let canApply = !this.chargeDetails?.yetToPay || (isPaying === 'Y')
    if (type == 'PROMO' && canApply && this.chargeDetails?.isPromoApplied)
      return 'Y'
    else if (type == 'COUPON' && canApply && this.chargeDetails?.isCouponApplied)
      return 'Y'
    else if (type == 'POINTS' && canApply && this.chargeDetails?.isPointsApplied)
      return 'Y'
    else if (type == 'GENERALDISCOUNT' && canApply && this.chargeDetails?.isGeneralDiscountApplied)
      return 'Y'
    else
      return 'N'
  }
  public getAppiledCoupons(type, isPaying: 'Y' | 'N') {
    console.log('getAppiledCoupons', type, isPaying, this.chargeDetails);
    if (this.getPromoCodeApplystatus(type, isPaying) === 'N') return null;
    if (type == 'PROMO') {
      return this.chargeDetails.appliedpromocodedtls
    } else if (type == 'COUPON') {
      let appliedcouponcodedtls = this.chargeDetails.appliedcouponcodedtls
      if (this.chargeDetails.isGeneralDiscountApplied) {
        appliedcouponcodedtls[0].generalDiscountDetails = this.chargeDetails.generalDiscountDetails;
      }
      return this.chargeDetails.appliedcouponcodedtls
    } else if (type == 'POINTS') {
      return this.chargeDetails.appliedPoints
    } else if (type == 'GENERALDISCOUNT') {
      return this.chargeDetails.generalDiscountDetails
    } else {
      return null
    }
  }

  public generateTransactionParams() {
        if (!this.selectedPatient || !this.selectedPatient.uhid) {
      console.error('Selected patient or patient uhid is null');
      return null;
    }
    return {
      linkedPersonId: this.selectedPatient?.personid,
      patientId: this.selectedPatient.uhid,
      amount: this.chargeDetails.netPayable.toString(),
      episodeType: 'R',
      encounterId: '0',
      currency: this.currency_code,
      localeCode: this.lang,
      requestType: this.selectedVisitType === 'HOMECARE' && !this.consultationSelections?.selectedPractitioner ? 'HCAPPTBK' : 'SRVREQ' // this.selectedVisitType == 'CLINIC' ||  ? 'SRVREQ' :'HCAPPTBK',
    }
  }

      get resourceId() {
    let resourceId=''
    if(this.healthPkg.selectedPract?.id){
      resourceId=this.healthPkg.selectedPract?.id
    }else if(this.healthPkg.choosenFacility?.controls?.packageCalendarResourceCode){
      let resources = this.healthPkg.choosenFacility.controls.packageCalendarResourceCode.split(',')
      if(resources.length==1)
      resourceId=resources[0] || this.healthPkg.choosenFacility.controls.packageCalendarResourceCode;
      else if(resources.length>1){
        resourceId=resources[0]
        if(this.healthPkg.rescheduleParams?.resourceId && resources.includes(this.healthPkg.rescheduleParams.resourceId)){
          resourceId=this.healthPkg.rescheduleParams.resourceId
        }
      }
    }else if(this.healthPkg.choosenFacility?.clinicCode){
      resourceId=this.healthPkg.choosenFacility.clinicCode
    }
    return resourceId
  }
  get resourceClass() {
    return this.healthPkg.selectedPract ? null : (this.healthPkg.choosenFacility?.controls?.packageCalendarResourceClass || this.healthPkg.choosenFacility?.resourceType)
  }


  public initReschedule() {
    // if (this.selectedVisitType === 'HOMECARE' && !this.consultationSelections?.selectedPractitioner) {
    //   this.initRescheduleForHomecare()
    // } else {
      this.initRescheduleForPackage()
    // }
  }


    fetchPackageDetails(pkg): void {
    if (!pkg) return;
    pkg = pkg?.packageInfo || pkg;
    const params = {
      isBackgroundProcess: false,
      patientId: pkg.patientId,
      facilityId: pkg.facilityId,
      package: [
        {
          packageCode: pkg.packageCode,
          packageSeq: pkg.subscriptionId,
          appointmentId: pkg.appointment_id,
          orderSetId: pkg.orderSetId
        }
      ]
    };

    this.packageService.getPackageDetail(params).subscribe((data: any) => {
      if(data.packageServDtls && data.packageServDtls.length>0){
        pkg['pkgList']=data.packageServDtls && data.packageServDtls.map((p)=>{
          p['desc']=p['serviceDesc'];
          return {desc:p['serviceDesc']};
        })
        pkg['serviceIncluded'] = data.packageServDtls
        pkg.groupedServices = this.groupServices(pkg, data.packageServDtls);
      }
      this.showPkgAccord = false;
      this.showInclServAccord = false;
      this.showInclServAccord = false;
      this.selectedPackageDtl = pkg;
      setTimeout(() => {
        this.setPercentForIndPkg(pkg);
      }, 500)
      if (data?.packageServDtls?.length) {
        data.packageServDtls.forEach((p: any) => (p.desc = p.serviceDesc));
        this.packageDetails = { serviceIncluded: data.packageServDtls };
      }
      this.applicableServices = this.selectedPackageDtl.serviceIncluded;
      this.groupedServices = this.selectedPackageDtl.groupedServices;
      this.packageService.setValue('groupedServices', this.groupedServices);
    });
  }

    public setPercentForIndPkg(pkg) {
    let progressCnt = document.getElementById("progress-container")
    if (!progressCnt) return
    let x = progressCnt.getAttribute("data-percentage");
    let progressEle = document.getElementById("progress");
    if (!progressEle) return;
    if(pkg.status=='Cancelled' || pkg.status=='Completed')
      progressEle.style.width = x ? x : '100' + '%'
    else 
      progressEle.style.width = x ? x : pkg.completedPercent + '%'
  } 

  private groupServices(selectedPkg, services) {
    let includedServices = selectedPkg._healthPackage?.packageDtls?.servicesApplicable;
    if(!includedServices) return []
    let groupedServices = this.apptService.groupServices(includedServices, services, selectedPkg)
    return groupedServices
  }

  public async showIncludedServices(services) {
    this.showServiceIncludedModal = true;
    this.selectedGrpService = services;
  }

    private initRescheduleForPackage() {
    let rescheduleParams = this.generateRequestParamsForPackage('PAY')
    this.packageService.setValue('newApptReq', rescheduleParams);
    this.packageService.setValue('oldApptDtls', this.rescheduleParams);
    this.selections = this.selections || {};
    let oldApptDetails = this.rescheduleParams;
    let payload = {
      newApptReq: rescheduleParams,
      oldApptDtls: oldApptDetails,
      locale: this.user.getCurrentLanguage()
    }
    this.apptService.reschedulePackage(payload).subscribe(data => {
      this.selections['confirmObj'] = data;
      this.selections['paymentError'] = false;
      this.apptConfirmDetails = {
      patientId: this.selectedPatient?.uhid,
      patientName: this.selectedPatient?.personname,
      packageDetails: this.rescheduleParams?.packageInfo?.packageDetails ? this.rescheduleParams?.packageInfo?.packageDetails : this.rescheduleParams?.packageDetails,
      facilityId: this.rescheduleParams?.facilityId ? this.rescheduleParams?.facilityId : this.selectedFacilityId,
      apptDateTime: data?.appointmentDateTime,
      paymentStatus: data?.status,
      apptRefNumber: data?.apptRefNumber,
      confirmReq: true
    }
    this.next.emit({data: this.apptConfirmDetails,state: "CONFIRM_PACKAGE",key: "confirmPkg",});
    })
  }
}
